export default __webpack_public_path__ + "static/media/accurate-rect.fcebc51d.png";